(() => {
  'use strict';
  // WhatsApp hand-off without a confirm dialog (user 2026-11-02).
  // - Phones/tablets (no hover, coarse pointer) open WhatsApp in the SAME tab. The old dialog opened a
  //   new tab; once the WhatsApp app took over, that tab stayed on about:blank and the shopper came back
  //   to an empty page (user's iPhone Chrome screenshot). The tab ending on about:blank also shows the
  //   browser hands wa.me straight to the app, so the shop page stays put (inference from that screenshot).
  // - Desktop keeps a new tab so the shop page stays open next to WhatsApp Web.
  // - Every link to a WhatsApp number gets a prefilled message saying it comes from the website; on a
  //   product page the message adds product, variant, SKU, quantity and link. A link that already has its
  //   own message (in-store enquiry) is left as is.
  // - The click is no longer prevented, so yl-ads-enquiry-tracking.js counts it as the WhatsApp conversion.
  // - Social profile links (Instagram, Facebook, TikTok, YouTube) also hand off to their apps on phones and
  //   left the same blank tab behind (user 2026-11-02: "页脚自媒体跳转也有跳空白页的问题"), so they follow
  //   the same rule: same tab on phones, new tab on desktop.
  const root = document.documentElement;
  if (root.dataset.ylWaBound !== 'true') {
    root.dataset.ylWaBound = 'true';
    let config = null;
    try { config = JSON.parse(document.querySelector('[data-yl-wa-config]')?.textContent || 'null'); } catch (_) {}
    const product = config && config.product;
    const sameTab = window.matchMedia('(hover: none) and (pointer: coarse)').matches;
    const socialHost = /(^|\.)(instagram\.com|facebook\.com|fb\.com|fb\.me|tiktok\.com|youtube\.com|youtu\.be)$/i;

    const recipient = (url) => {
      if (url.protocol !== 'https:' && url.protocol !== 'http:') return '';
      if (url.hostname === 'wa.me') return url.pathname.replace(/^\//, '').replace(/\/$/, '').replace(/^\+/, '');
      if (['api.whatsapp.com', 'web.whatsapp.com'].includes(url.hostname) && url.pathname.replace(/\/$/, '') === '/send') return (url.searchParams.get('phone') || '').replace(/^\+/, '');
      return '';
    };

    const productLines = () => {
      const form = document.querySelector('.yl-product-cta__form');
      const input = form?.querySelector('input[name="id"]:checked, input[type="hidden"][name="id"], select[name="id"]');
      const selectedId = input?.value || new URL(location.href).searchParams.get('variant') || product.selectedId;
      const variant = product.variants.find((item) => String(item.id) === String(selectedId));
      const productUrl = new URL(product.url, location.origin);
      if (variant) productUrl.searchParams.set('variant', variant.id);
      const lines = [product.intro, product.title];
      if (variant?.title && variant.title !== 'Default Title') lines.push(product.variantLabel + ': ' + variant.title);
      if (variant?.sku) lines.push(product.skuLabel + ': ' + variant.sku);
      const quantity = form?.querySelector('[name="quantity"]')?.value;
      if (quantity && /^\d+$/.test(quantity) && Number(quantity) > 0) lines.push(product.quantityLabel + ': ' + quantity);
      lines.push(productUrl.href);
      return lines;
    };

    const message = () => {
      if (product) {
        try { return productLines().join('\n'); } catch (_) {}
      }
      return config?.intro || '';
    };

    document.addEventListener('click', (event) => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
      const link = event.target.closest('a[href]');
      if (!link || link.hasAttribute('download')) return;
      // Build from the link's original href every time, so repeat taps never stack messages.
      const base = link.dataset.ylWaBase || link.href;
      let url;
      try { url = new URL(base); } catch (_) { return; }
      if (!/^\d+$/.test(recipient(url))) {
        if (sameTab && socialHost.test(url.hostname)) link.removeAttribute('target');
        return;
      }
      link.dataset.ylWaBase = base;
      if (!url.searchParams.get('text')) {
        const text = message();
        if (text) url.searchParams.set('text', text);
      }
      link.href = url.href;
      if (sameTab) {
        link.removeAttribute('target');
      } else {
        link.target = '_blank';
        link.rel = 'noopener';
      }
    });
  }

  const fab = document.querySelector('[data-yl-whatsapp-fab]');
  if (!fab) return;
  let scheduled = false;
  const avoidPurchaseButtons = () => {
    scheduled = false;
    const fabRect = fab.getBoundingClientRect();
    if (!fabRect.width || !fabRect.height) return;
    const buttons = document.querySelectorAll('form[action*="/cart/add"] button[type="submit"], button[name="checkout"], .yl-species-card button[type="submit"]');
    const overlaps = Array.from(buttons).some((button) => {
      const rect = button.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < innerHeight && rect.left < fabRect.right + 12 && rect.right > fabRect.left - 12 && rect.top < fabRect.bottom + 12 && rect.bottom > fabRect.top - 12;
    });
    fab.toggleAttribute('data-yl-avoid-purchase', overlaps);
  };
  const schedule = () => {
    if (!scheduled) { scheduled = true; requestAnimationFrame(avoidPurchaseButtons); }
  };
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('pageshow', schedule);
  window.addEventListener('load', schedule);
  document.addEventListener('change', schedule);
  if ('ResizeObserver' in window) new ResizeObserver(schedule).observe(document.body);
  schedule();
})();
